import React from 'react';
import { Link } from 'react-router-dom';
import { partnerFirms } from '../data/siteContent';

const team = [
  {
    name: 'Ed Lyon',
    title: 'Managing Partner & CPA',
    focus: 'Tax strategy for high-income entrepreneurs and advisors.',
  },
  {
    name: 'Maya Patel',
    title: 'Principal Tax Strategist',
    focus: 'DEP/credits audits, MERP plans, multi-entity optimization.',
  },
  {
    name: 'Jordan Santiago',
    title: 'Director of Advisor Partnerships',
    focus: 'Builds referral programs and partner co-branded journeys.',
  },
];

export default function About() {
  return (
    <div className="bg-gray-warm min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-12">
        <section className="space-y-4">
          <p className="text-sm uppercase tracking-[0.4em] text-gray-500">About the firm</p>
          <h1 className="text-4xl font-bold text-charcoal">CPA-led tax strategy, built for trusted advisors</h1>
          <p className="text-gray-600 text-lg">
            Tax Strategy Center is a compliance-first practice that partners with CPAs, wealth advisors, and multi-entity owners to deliver conservative but high-return planning. We publish guides, speak on the Lyon Share podcast, and keep every engagement defensive and well-documented.
          </p>
        </section>

        <section className="rounded-3xl bg-white p-10 shadow-lg">
          <div className="grid gap-8 md:grid-cols-3">
            {team.map((member) => (
              <article key={member.name} className="space-y-2">
                <p className="text-sm uppercase tracking-[0.3em] text-gray-400">{member.title}</p>
                <h2 className="text-xl font-semibold text-charcoal">{member.name}</h2>
                <p className="text-gray-600 text-sm">{member.focus}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-3xl font-semibold text-charcoal">Firm philosophy</h2>
          <p className="text-gray-600">
            We focus on well-documented strategies that stand up to audits and CPAs alike. Every recommendation includes compliance checklists, and we never push aggressive ERC mills or fake dependents. We exist to be your trusted “second opinion” on complex tax strategy.
          </p>
          <p className="text-gray-600">
            Our publishing calendar includes the High-Income Tax Playbook, breakouts on CPA-aligned reimbursement plans, and the Lyon Share podcast interviews.
          </p>
        </section>

        <section className="space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-3xl font-semibold text-charcoal">Advisor partnerships</h2>
            <Link to="/partners" className="text-sm font-semibold text-primary">
              View partners →
            </Link>
          </div>
          <div className="grid gap-6 md:grid-cols-2">
            {partnerFirms.map((partner) => (
              <div key={partner.name} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
                <p className="text-sm font-semibold text-charcoal">{partner.name}</p>
                <p className="text-gray-600 text-sm">{partner.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
